import React, { memo } from 'react';
export const ExtendedTestimonialsSection = ({
  isInitial = false
}: {
  isInitial?: boolean;
}) => {
  const initialTestimonials = [{
    initials: 'MP',
    name: 'María P.',
    city: 'Buenos Aires',
    desc: 'Mamá de alumna Cambridge Starters · Instituto bilingüe · Buenos Aires',
    quote: 'Mi hija tiene 8 años y rinde Cambridge Starters en junio. Yo no sé nada de inglés y siempre me sentí excluida de su preparación. Con el Módulo 1 del English en Familia pude acompañarla por primera vez. La guía en español lo explica todo. Aprobó con Distinction.'
  }, {
    initials: 'RC',
    name: 'Roberto C.',
    city: 'Córdoba',
    desc: 'Papá de alumno Cambridge KET · Córdoba Capital',
    quote: 'Mi hijo de 14 rindió KET y no pasó la primera vez. Compramos el pack y usamos el Sistema Espejo juntos todas las noches. Él hacía los ejercicios en inglés, yo leía la guía en español y lo podía corregir. Aprobó KET con Merit en el segundo intento.'
  }, {
    initials: 'SL',
    name: 'Silvina L.',
    city: 'Rosario',
    desc: 'Mamá de alumna Cambridge PET · Instituto privado · Rosario',
    quote: 'El Mock Test del Módulo 2 fue exactamente lo que necesitaba mi hija para perder el miedo al examen. Y el Bono de Flashcards lo usamos en el auto camino al instituto. Aprobó PET a los 15 años. Este pack cambió la dinámica de estudio en casa.'
  }];
  const extendedTestimonials = [{
    initials: 'MP',
    name: 'María P.',
    city: 'Buenos Aires',
    desc: 'Mamá de alumna 8 años · Instituto bilingüe CABA',
    quote: 'Compré el pack el domingo. El lunes a la tarde ya estábamos haciendo actividades juntos con mi hija. Yo leía la guía en español y ella hacía los ejercicios en inglés. Primera vez en 2 años que pude ayudarla de verdad. Aprobó Starters con Distinction.'
  }, {
    initials: 'RC',
    name: 'Roberto C.',
    city: 'Córdoba',
    desc: 'Papá de alumno 14 años · Córdoba Capital',
    quote: 'Mi hijo aplazó KET la primera vez. Compramos el Módulo 2 y usamos el Sistema Espejo todas las noches. Yo no sé inglés pero podía corregirlo con las respuestas de la guía de padres. Aprobó KET con Merit en el segundo intento.'
  }, {
    initials: 'SL',
    name: 'Silvina L.',
    city: 'Rosario',
    desc: 'Mamá de alumna 15 años · Instituto privado Rosario',
    quote: 'Las Flashcards del Bono 1 las usamos en el auto camino al instituto. Mi hija las repasa sola y yo le pregunto leyendo el español del otro lado. Aprobó PET a los 15 años. Sin profesor particular extra.'
  }, {
    initials: 'GP',
    name: 'Gabriela P.',
    city: 'Mendoza',
    desc: 'Mamá de alumno 16 años · Mendoza',
    quote: 'El Grammar Sin Vueltas es exactamente lo que necesitaba. Mi hijo confundía el Past Simple con el Present Perfect todo el tiempo. Con el código de colores del Módulo 3 lo memorizó en una semana. El examen Cambridge B1 aprobado.'
  }, {
    initials: 'LF',
    name: 'Laura F.',
    city: 'La Plata',
    desc: 'Mamá de alumna 11 años · La Plata',
    quote: 'El Plan de 30 días del Bono 3 nos organizó a toda la familia. Sabíamos exactamente qué practicar cada día. No hubo más caos en la semana previa al examen. Mi hija llegó tranquila y segura.'
  }, {
    initials: 'JR',
    name: 'Javier R.',
    city: 'Tucumán',
    desc: 'Papá de alumno 9 años · Tucumán',
    quote: 'Nunca imaginé que podría ayudar a mi hijo con inglés. La pronunciación en rojo en cada tabla me permite decirle cómo suena cada palabra. Parezco un profesor y no sé nada de inglés. El pack es un milagro para padres como yo.'
  }, {
    initials: 'AM',
    name: 'Andrea M.',
    city: 'CABA',
    desc: 'Mamá de alumna 13 años · CABA',
    quote: 'Las Speaking Cards del Bono 2 salvaron el oral de Cambridge de mi hija. Practicamos rol play en casa yo con la guía en español y ella respondiendo en inglés. El examinador le dijo que fue la candidata más preparada del día.'
  }];
  const data = isInitial ? initialTestimonials : extendedTestimonials;
  return <section className={`py-10 md:py-16 px-4 md:px-6 ${isInitial ? 'bg-familia-bg' : 'bg-familia-card'}`} data-id="element-54">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-55">
        {!isInitial && <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold text-center mb-8 md:mb-12" data-id="element-56">
            Lo que dicen las familias que ya <br className="hidden sm:block" data-id="element-57" />{' '}
            usan el English en Familia:
          </h2>}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-58">
          {data.map((t, i) => <div key={i} className="bg-familia-section border border-familia-cyan/25 p-5 md:p-8 rounded-2xl card-hover flex flex-col" data-id="element-59">
              <div className="flex items-center gap-4 mb-4 md:mb-6" data-id="element-60">
                <div className="w-12 h-12 rounded-full bg-familia-cyan text-familia-bg flex items-center justify-center font-bold text-lg shrink-0" data-id="element-61">
                  {t.initials}
                </div>
                <div data-id="element-62">
                  <div className="text-familia-gold text-sm mb-1" data-id="element-63">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <div className="font-bold text-sm" data-id="element-64">{t.name}</div>
                  <div className="text-familia-gray text-[10px] uppercase tracking-wider" data-id="element-65">
                    {t.city}
                  </div>
                </div>
              </div>
              <p className="text-white/90 italic mb-4 md:mb-6 flex-grow leading-relaxed text-[15px]" data-id="element-66">
                "{t.quote}"
              </p>
              <div className="text-xs font-semibold text-familia-cyan/90 pt-4 border-t border-white/10" data-id="element-67">
                {t.desc}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};